import {
  ActionList,
  ActionListItem,
  Divider,
  GridItem,
  Link,
  PrimaryTag,
  Text,
} from "@certn/cascadia-react";
import React from "react";
import { Trans } from "react-i18next";

import { EducationModal } from "./EducationModal";
import { Education } from "./type";
import { convertToTitleCase } from "./utils";

type EducationListProps = {
  educationQualifications: Education[];
  onSave: (education: Education) => void;
  onDelete: (index: number) => void;
  testID?: string;
  requireHighestLevel: boolean;
};

export function EducationList({
  educationQualifications,
  onSave,
  onDelete,
  testID,
  requireHighestLevel,
}: EducationListProps) {
  const highestEducationIndex = educationQualifications.findIndex(
    ({ highest_level }) => highest_level
  );

  return (
    <GridItem>
      <ActionList testID={testID}>
        {educationQualifications.map((education) => (
          <React.Fragment key={education.index}>
            <ActionListItem
              title={education.degree ?? "-"}
              tag={
                education.highest_level ? (
                  <PrimaryTag type="subtle">
                    <Trans>Highest level</Trans>
                  </PrimaryTag>
                ) : (
                  education.current && (
                    <PrimaryTag type="subtle">
                      <Trans>In progress</Trans>
                    </PrimaryTag>
                  )
                )
              }
              trailing={
                <EducationModal
                  index={education.index}
                  education={education}
                  onSave={onSave}
                  onDelete={() => onDelete(education.index)}
                  allowHighest={
                    requireHighestLevel &&
                    (highestEducationIndex === -1 ||
                      highestEducationIndex === education.index)
                  }
                  trigger={
                    <Link
                      linkStyle="monochrome"
                      textStyle="global/body-secondary"
                      testID="education-edit-education-button"
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  }
                />
              }
            >
              <Text style="global/body-secondary" color="text-weak">
                {convertToTitleCase(education.institution)}
              </Text>
            </ActionListItem>
            <Divider />
          </React.Fragment>
        ))}
      </ActionList>
    </GridItem>
  );
}
